import { render, staticRenderFns } from "./customerLogsPage.vue?vue&type=template&id=e35df1b8&"
import script from "./customerLogsPage.vue?vue&type=script&lang=ts&"
export * from "./customerLogsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports